export default __webpack_public_path__ + "static/media/our-services-edu-further-education.6d95f886.jpg";